import type { ReactNode } from "react";
import { Link } from "react-router";
import { SectionHeader } from "../../components/design-system/index.js";

/**
 * Shared shell for all `/fire/*` sub-pages (Phase 13.5).
 *
 * Centralizes: the SectionHeader title/sub block, the "← FIRE hub" back
 * link, and the `max-w-4xl` page chrome. Each sub-page passes in its
 * own children — the tile/component(s) it owns plus its
 * SuggestedPromptsTile — without rebuilding the wrapper.
 */
export function FireSubPageLayout({
  title,
  sub,
  children,
}: {
  readonly title: string;
  readonly sub?: string;
  readonly children: ReactNode;
}) {
  return (
    <div className="mx-auto max-w-4xl space-y-6 px-4 py-8 sm:px-6">
      <SectionHeader
        title={title}
        sub={sub}
        action={
          <Link
            to="/fire"
            className="rounded-md border border-[var(--color-border-default)] px-3 py-1.5 text-xs font-medium text-[var(--color-muted)] hover:bg-[var(--color-elevated)] hover:text-[var(--color-text)]"
          >
            ← FIRE hub
          </Link>
        }
      />
      {children}
    </div>
  );
}
